module.exports = __webpack_public_path__ + "media/components/images/panels/1-b-85f7a5a7a587e457d5096f25051e847f.jpeg";